import { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { Col, Row } from 'reactstrap';

import { getEntity } from '../../../services/entity/entity-service';
import { buildActivityCard } from '../../../services/activity/activity-service';
import { buildGameOptions, playActiveSession } from '../../../services/game-session/game-session-service';
import { isResume } from '../../../services/player-game-session-service/player-game-session-service';

import DateRangePicker from '../../components/date-range-picker/date-range-picker';
import FormSection from '../../components/form-section/form-section';
import Input from '../../components/input/input';
import LoadingSpinner from '../../components/loading-spinner/loading-spinner';
import PlayerDashboardButtons from '../../components/player-dashboard-buttons/player-dashboard-buttons';
import PlayerGameSessionCard from '../../components/player-game-session-card/player-game-session-card';

import { _getPlayerGameSessions } from '../../../modules/player_game_session';
import { getGameSessionActivities } from '../../../modules/game_session_activity';
import { getGameSessions } from '../../../modules/game_session';
import { getPlayerGameSessionActivities } from '../../../modules/player_game_session_activity';
import { getPlayer } from '../../../modules/player';
import { getResults } from '../../../modules/result';
import { getUser } from '../../../modules/user';
import { setPageTitle } from '../../../modules/application/pages';

import './player-game-sessions.css';

class PlayerGameSessions extends Component {
  constructor(props) {
    super(props);
    this.state = {
      player: {},
      playerGameSessions: [],
      filterStartDate: null,
      filterStopDate: null,
      filterName: '',
    };

    this.setPlayer = this.setPlayer.bind(this);
    this.onClickPlayActiveSession = playActiveSession.bind(this);
  }

  componentDidMount() {
    if (this.props.match.params.id && parseInt(this.props.match.params.id, 10) !== this.state.player.id) {
      this.setPlayer(this.props.match.params.id);
    }
  }

  async setPlayer(playerId) {
    const { dispatch } = this.props;
    const gameOptions = await buildGameOptions(this.props);

    const player = await getEntity(dispatch, getPlayer(playerId));
    const gameSessions = await getEntity(dispatch, getGameSessions([{ id: `[${player.game_sessions}]` }]), true);

    for (const gameSession of gameSessions) {
      const activities = await getEntity(
        dispatch,
        getGameSessionActivities([{ id: `[${gameSession.game_session_activities}]` }]),
        true
      );
      const activityCards = activities.map((activity) => buildActivityCard(activity, gameOptions, true));

      gameSession._activities = activities;
      gameSession._activityCards = activityCards;
    }

    const playerGameSessions = await getEntity(dispatch, _getPlayerGameSessions([{ player: player.id }], '-id'), true);
    const playerGameSessionActivities = await getEntity(
      dispatch,
      getPlayerGameSessionActivities([{ player: player.id }]),
      true
    );
    const results = await getEntity(dispatch, getResults([{ player: player.id }]), true);

    const _users = [];

    for (const playerGameSession of playerGameSessions) {
      const activities = playerGameSessionActivities.filter((activity) =>
        playerGameSession.activities.includes(activity.id)
      );

      activities.forEach((activity) => {
        activity._result = results.find((result) => activity.results.length > 0 && activity.results[0] === result.id);
      });

      const _isResume = isResume(playerGameSession, activities);

      const activityCards = activities.map((activity, index) =>
        buildActivityCard(
          activity,
          gameOptions,
          true,
          null,
          null,
          null,
          _isResume && playerGameSession.active_activity_index === index
        )
      );

      playerGameSession._gameSession = gameSessions.find(
        (gameSession) => gameSession.id === playerGameSession.game_session
      );
      playerGameSession._activities = activities;
      playerGameSession._activityCards = activityCards;

      if (!playerGameSession.user) {
        continue;
      }

      let _user = _users[playerGameSession.user];

      if (!_user) {
        _user = await getEntity(dispatch, getUser(playerGameSession.user));
      }

      _users[playerGameSession.user] = _user;
      playerGameSession._user = _user;
    }

    for (const gameSession of gameSessions) {
      gameSession._playerGameSessions = playerGameSessions.filter(
        (playerGameSession) => gameSession.id === playerGameSession.game_session
      );
    }

    this.setState({ player, playerGameSessions });
    this.props.dispatch(setPageTitle(player.name));
  }

  render() {
    return (
      <div className="px-1">
        <FormSection component={this.playerSessionResults()} />
      </div>
    );
  }

  playerSessionResults = () => {
    const { isTherapistRole, user, currentUserId, history } = this.props;
    const { player, playerGameSessions, filterName, filterStartDate, filterStopDate } = this.state;

    const filteredPlayerGameSessions = playerGameSessions.filter((playerGameSession) => {
      const createdDate = new Date(playerGameSession._created);
      const _filterStopDate = filterStopDate && new Date(filterStopDate.valueOf());
      _filterStopDate && _filterStopDate.setDate(_filterStopDate.getDate() + 1);

      if (filterStartDate && createdDate < filterStartDate) {
        return false;
      }
      if (_filterStopDate && createdDate >= _filterStopDate) {
        return false;
      }
      if (filterName && !playerGameSession.name.toLowerCase().includes(filterName.toLowerCase())) {
        return false;
      }
      return playerGameSession;
    });

    const filteredPlayerGameSessionsComponent =
      filteredPlayerGameSessions &&
      filteredPlayerGameSessions.map((playerGameSession) => (
        <Col className="mp-0" key={playerGameSession.id}>
          <PlayerGameSessionCard
            playerGameSession={playerGameSession}
            user={user}
            player={player}
            onClickViewSession={() => {
              history.push(`/player/${player.id}/sessions/${playerGameSession.id}`);
            }}
            onClickResumeSession={() => {
              this.onClickPlayActiveSession(player, currentUserId, playerGameSession);
            }}
            onClickPlayActiveSession={() => {
              this.onClickPlayActiveSession(player, currentUserId, null, playerGameSession._gameSession);
            }}
          />
        </Col>
      ));

    const filterComponent = (
      <Row className="ml-0 mr-3 my-0 p-0">
        <p className="mr-1 my-auto p-0 very-small secondary-color">Filters:</p>
        <div className="mx-1 my-0 p-0">
          <Input
            style={{ fontSize: 12 }}
            className="py-1"
            formgroupclassname="mp-0"
            placeholder="Session Name"
            onChange={(filterName) => {
              this.setState({ filterName });
            }}
          />
        </div>
        <DateRangePicker
          small
          _onDatesChange={(filterStartDate, filterStopDate) => {
            this.setState({ filterStartDate, filterStopDate });
          }}
        />
      </Row>
    );
    return (
      <div className="mp-0 container-fluid">
        <PlayerDashboardButtons player={player} activePage="playerGameSessions" isTherapistRole={isTherapistRole} />

        <Col className="mp-0 text-left">
          <FormSection
            sectionLabel="In Progress or Played Game Sessions"
            headerComponent={filterComponent}
            component={
              <div className="m-0 px-0 py-2 text-left container-fluid">
                {filteredPlayerGameSessionsComponent}
                {!player.id && <LoadingSpinner />}
              </div>
            }
          />
        </Col>
      </div>
    );
  };
}

const withState = connect((state) => {
  const { user } = state;

  return {
    user: user,
    currentUserId: user.currentUserId,
    isTherapistRole: user.isTherapistRole,
  };
});

export default withRouter(withState(PlayerGameSessions));
